export default "__VITE_ASSET__203d8598__"